module.exports = __webpack_public_path__ + "static/media/P6.20e80057.png";